import { QCNamingConvention } from './qc-naming-convention';

export class QCTapeAssetNamingConvention extends QCNamingConvention {

  get description(): string {
    return "Tape Asset";
  }

  get generatedName(): string {
    let elementTypes = {
      'Digital Master': 'DM',
      'Domestic Source Master': 'DSM',
      'Element Reel': 'ER',
      'Production Master': 'PM',
      'Unfinished Master': 'UM'
    }
    let components = [
      this.foreignEpisode,
      elementTypes[this.elementType],
      this.standard,
      this.format,
      this.aspectRatio,
      this.programTitle
    ]

    let name = components.filter((x) => x != null).join('_');
    if (this.revision != null) {
      name += '_R' + this.revision
    }
    return name;
  }

  static get requiredComponents(): string[] {
    return [
      'aspectRatio',
      'elementType',
      'foreignEpisode',
      'format',
      'programTitle',
      'standard'
    ];
  }

}


// WEBPACK FOOTER //
// ./src/app/qc/qc-naming-conventions/qc-tape-asset-naming-convention.ts